import PressureSimulation from './PressureSimulation';
export default PressureSimulation;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/PressureSimulation/index.js